import { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { JSONLD, Generic } from "react-structured-data";
// import reactLogo from './assets/react.svg'
// import viteLogo from '/vite.svg'
// import { PiCaretDownBold } from "react-icons/pi";
import { FaArrowDown } from 'react-icons/fa';

import './App.css'
import './assets/css/style.min.css'
import Home from './pages/Home';
import Login from "./pages/Login";
import LegalUpdateEditor from "./pages/LegalUpdateEditor";
/* import Navigation from './components/Navigation'
import header from './assets/img/header.jpg'
import justiceScales from './assets/img/justiceScales.webp'
import ladyJusticeDesk from './assets/img/ladyJusticeDesk.webp'
import ladyJustice from './assets/img/ladyJustice.webp'
import lawyerWig from './assets/img/lawyerWig.webp'
import scalesOfJustice from './assets/img/scalesOfJustice.png'
import teamBg from './assets/img/teamBg.png'
import contactUs from './assets/img/contactUs.webp' */
import { AnimatePresence, delay, motion, useInView } from 'framer-motion';
// import { IoSend } from 'react-icons/io5';
// import { RiSendPlane2Line } from 'react-icons/ri';
import Ftr from './components/Ftr';
import Lottie from 'lottie-react';

import Ptn from './components/Ptn';
import Intro from './components/Intro';
import ScrollInfo from './components/ScrollInfo';

import { terminal } from 'virtual:terminal'
import { TextProvider } from './components/TextContext';
import Toaster from './components/Toaster';
import ScrollToTop from './components/ScrollToTop';

terminal.log('Hey terminal! A message from the browser')


function App() {
  /* const [intro, setIntro] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIntro(false);
    }, 3000)
  }, []); */

  /* const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Murage Juma & Company Advocates",
    "url": "https://jncmlaw.co.ke",
    "description": "Dedicated to Justice, Driven by Integrity",
    "publisher": {
      "@type": "Organization",
      "name": "Murage Juma & Company Advocates",
      "logo": "https://jncmlaw.co.ke/logo.png"
    }
  }; */

  // const whatWeDoRef = useRef(null)

  const fadeIntro = {
    initial: { opacity: 0 },
    animate: { opacity: 1, y: 0, transition: { ease: "easeInOut", duration: 0.75 } },
    exit: { opacity: 0, y: 0, transition: { ease: "easeInOut", duration: 0.75 } },
  };

  const fadeIn = {
    initial: {
      opacity: 0,
      y: 30
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        ease: "easeInOut",
        duration: 0.35,
        delay: 1
      }
    },
    exit: {
      opacity: 0,
      y: 30,
      transition: {
        ease: "easeInOut",
        duration: 0.75
      }
    },
  };


  const parentVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        // duration: 0.5,
        staggerChildren: 0.35,
        when: "beforeChildren",
      },
    },
  };

  const childVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    },
  };

  const infoRef = useRef(null)
  const isInView = useInView(infoRef, { once: true });

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 150); // Change 150 to your preferred scroll distance
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <JSONLD>
        <Generic
          type="WebSite"
          jsonldtype="WebSite"
          schema={{
            name: "Murage Juma & Company Advocates",
            url: "https://jncmlaw.co.ke",
            description: "Dedicated to Justice, Driven by Integrity",
            publisher: {
              "@type": "Organization",
              name: "Murage Juma & Company Advocates",
              logo: "https://jncmlaw.co.ke/logo512.png",
            },
          }}
        />
      </JSONLD>
      <Helmet>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "name": "Murage Juma & Company Advocates",
              "url": "https://jncmlaw.co.ke",
              "description": "Dedicated to Justice, Driven by Integrity",
              "publisher": {
                "@type": "Organization",
                "name": "Murage Juma & Company Advocates",
                "logo": "https://jncmlaw.co.ke/logo512.png",
              },
            }),
          }}
        />
        <title>Murage Juma & Company Advocates</title>
        <meta name="description" content='Dedicated to Justice, Driven by Integrity' />
        <meta name="author" content="Designed by Mutai" />
        <meta name="publisher" content="Designed by Mutai" />
        <meta name="robots" content="index, follow" />
        <meta name="google-site-verification" content="mmxN3C8BY0isfRqwrpBiUKir_kx3CnHvOHQcRDrw9Ic" />
        <meta name="keywords" content="joseph murage, joe murage, joseph nicholas Murage, josé murage, juma kagoro, john patrick machira, law firm, law associates, kenya law, kenya lawyers, kenyan law firm, murage juma & company advocates, commissioners for oaths, notaries public, agri business, agri, debt collection, succession law, intellectual property law, sale of property, sale of assets, family law, civil litigation, commercial litigation, natural resource law research, energy and natural resource law research, legal entity formation, securities perfection, banking securities, project finance securities, Civil and Commercial Litigation, Immigration Law Advisory and Ancillary Services" />

        {/* Open Graph (Facebook, LinkedIn) */}
        <meta property="og:title" content="Murage Juma & Company Advocates" />
        <meta property="og:description" content="Dedicated to Justice, Driven by Integrity" />
        <meta property="og:site_name" content="Murage Juma & Company Advocates" />
        <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content='https://jncmlaw.co.ke/' />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Murage Juma & Company Advocates" />
        <meta name="twitter:description" content="Dedicated to Justice, Driven by Integrity" />
        <meta name="twitter:image" content="%PUBLIC_URL%/twitter-image.jpg" />

      </Helmet>
      <TextProvider>
        <Router>
          <Routes>
            <Route path="/" element={
              <Home
                isScrolled={isScrolled}
              />
            } />
            <Route path="/login" element={
              <Login
                isScrolled={isScrolled}
              />
            } />
            <Route path="/legalUpdateEditor" element={
              <LegalUpdateEditor
                isScrolled={isScrolled}
              />
            } />
          </Routes>
          <div
            className='relative z-[800]'
          >
            <ScrollToTop />
          </div>
          <div
            className='relative z-[999]'
          >
            <Toaster />
          </div>
          <div
            className='relative z-[600]'
          >
            <Ftr />
          </div>
        </Router>
      </TextProvider>
    </>
  )
}

export default App
